export default function (configuration, configurations) {
  configuration.forEach(config => {
    configurations.content.forEach(content => {
      if (content.layerId !== config.layer_id) {
        return;
      }

      content.choices.forEach(choice => {
        if (choice._id !== config.choice_id) {
          return;
        }

        const hasLinkedProduct = choice.manage_stock && choice.manage_stock === 'linked';
        const shouldUseLinkedPrice = hasLinkedProduct && !choice.override_linked_price;

        if (shouldUseLinkedPrice) {
          config.extra_price = choice.linked_product_price || 0;
          return;
        }

        config.extra_price = choice.extra_price;
      });
    });
  });
}
